﻿'use strict';

angular.module('ntmApp').factory('BreadCrumbs', ['$location', 'Constants', 'Utils', function ($location, Constants, Utils) {

    function BreadCrumbs() {

        var self = this;

        var onBreadCrumbChangingEvent = null;
        var onViewTypeChangedEvent = [];
        var onLocationChangedEvent = null;
        var onRoomChangedEvent = null;

        self.setViewTypes = function (viewTypes) {
            self.viewTypes = viewTypes.map(function (item) {
                return {
                    id: item.unitId || 0,
                    value: item.isUserUnit ? '{0} (my unit)'.format(item.unitName) : item.unitName,
                    unitName: item.unitName,
                    schedulers: item.schedulers,
                    order: item.order
                };
            });

            if (!Utils.IsNull(self.selectedViewType.id)) {
                self.viewTypes.forEach(function (item) {
                    if (item.id.toString() === self.selectedViewType.id.toString()) {
                        self.selectedViewType = item;
                    }
                });
            } else {
                self.selectedViewType = self.viewTypes[0];
            }
        };

        self.changeViewType = function (type) {

            var performChangeViewType = function () {

                emptyBreadCrumbs();

                self.locations = [];
                self.rooms = [];

                $location.search('type', type.id);
                $location.search('id', null);
                $location.search('room', null);
                $location.search('facility', null);
                if(self.showEmergency) {
                    self.closeEmergency();
                }

                self.selectedViewType = type;

                if (onViewTypeChangedEvent.length > 0) {
                    onViewTypeChangedEvent.forEach(i => i());
                }
            };

            if (onBreadCrumbChangingEvent) {
                onBreadCrumbChangingEvent(performChangeViewType);
            } else {
                performChangeViewType();
            }
        };

        self.setLocations = function (locations) {
            self.locations = locations.breadcrumbItems;

            if (!Utils.IsNull(self.selectedLocation.id)) {
                var location = self.locations.firstOrDefault(function (item) {
                    return item.id && item.id.toString() === self.selectedLocation.id.toString();
                });

                if (location) {
                    self.selectedLocation = location;
                }

            } else {
                self.selectedLocation = locations[0];
            }
        };

        self.changeLocation = function (location) {

            var performChangeLocation = function () {

                self.selectedLocation = location;
                self.selectedRoom = {};

                self.rooms = [];

                var locationChanged = !$location.search().id || $location.search().id.toString() !== location.id.toString();

                $location.search('id', location.id);
                $location.search('room', null);
                $location.search('facility', null);

                if (onLocationChangedEvent) {
                    onLocationChangedEvent(locationChanged);
                }
            };

            if (onBreadCrumbChangingEvent) {
                onBreadCrumbChangingEvent(performChangeLocation);
            } else {
                performChangeLocation();
            }
        };

        self.changeLocationById = function (locationId) {
            
            var location = self.locations.firstOrDefault(function (item) {
                return item.id && item.id.toString() === locationId.toString();
            });

            if (location) {
                self.changeLocation(location);
            }
        };

        self.setRooms = function (rooms) {
            self.rooms = rooms;

            if (self.selectedRoom.roomNumber) {
                var room = self.rooms.firstOrDefault(function (item) {
                    return item.room === self.selectedRoom.roomNumber;
                });

                if (room) {
                    self.selectedRoom = room;
                }

            } else {
                self.room = rooms[0];
            }
        };

        self.changeRoom = function (room) {

            var performChangeRoom = function () {

                self.selectedRoom = room;

                $location.search('facility', room.facilityCode);
                $location.search('room', room.roomNumber);

                if (onRoomChangedEvent) {
                    onRoomChangedEvent();
                }
            };

            if (onBreadCrumbChangingEvent) {
                onBreadCrumbChangingEvent(performChangeRoom);
            } else {
                performChangeRoom();
            }
        };
		
		self.setRoomDetails = function (details) {
			self.selectedRoom.roomDetails = details;
		};

        self.changeRoomById = function (tile) {

            var room = self.rooms.firstOrDefault(function (item) {
                return item.roomNumber === tile.title && item.facilityCode === tile.facilityCode;
            });

            if (room) {
                self.changeRoom(room);
            }
        };

        self.onBreadCrumbChanging = function (event) {
            onBreadCrumbChangingEvent = event;
        };

        self.onViewTypeChanged = function (event) {
            onViewTypeChangedEvent.push(event);
        };

        self.onLocationChanged = function (event) {
            onLocationChangedEvent = event;
        };

        self.onRoomChanged = function (event) {
            onRoomChangedEvent = event;
        };

        self.loadEmergency = function () {
            $location.search('emergency', true);
            self.showEmergency = true;
        };

        self.closeEmergency = function () {
            $location.search('emergency', null);
            self.showEmergency = false;
        };

        self.getCurrentLevel = function () {

            if (self.selectedRoom.roomNumber) {
                return Constants.DailyPlanLevels.LEVEL3;
            }

            if (!Utils.IsNull(self.selectedLocation.id)) {
                return Constants.DailyPlanLevels.LEVEL2;
            }

            return Constants.DailyPlanLevels.LEVEL1;
        };

        self.clearSearchParams = function () {
            $location.search('type', null);
            $location.search('id', null);
            $location.search('room', null);
            $location.search('facility', null);
        };

        function emptyBreadCrumbs() {
            self.selectedViewType = {};
            self.selectedLocation = {};
            self.selectedRoom = {};
        }

        function initDefaultBreadCrumbs() {

            emptyBreadCrumbs();
            self.showEmergency = $location.search().emergency;
            self.selectedViewType.id = $location.search().type;
            self.selectedLocation.id = $location.search() && $location.search().id ? $location.search().id : null;
            self.selectedRoom.roomNumber = $location.search() && $location.search().room ? $location.search().room : null;
            self.selectedRoom.facilityCode = $location.search() && $location.search().facility ? $location.search().facility : null;
        }

        function initialize() {

            self.viewTypes = [];
            self.locations = [];
            self.rooms = [];

            initDefaultBreadCrumbs();
        }

        initialize();
    }

    return (BreadCrumbs);

}]);